import { useMutation } from "@tanstack/react-query";
import { LogIn } from "lucide-react";
import { FormEvent, useState } from "react";
import { adminApi, setAdminToken } from "../api";

export function LoginPage({ onLogin }: { onLogin: () => void }) {
  const [email, setEmail] = useState("teste@teste.com");
  const [password, setPassword] = useState("teste");
  const login = useMutation({
    mutationFn: adminApi.login,
    onSuccess: (data) => {
      setAdminToken(data.token);
      onLogin();
    }
  });

  function submit(event: FormEvent) {
    event.preventDefault();
    login.mutate({ email, password });
  }

  return (
    <main className="grid min-h-screen place-items-center bg-soft px-4">
      <form onSubmit={submit} className="w-full max-w-sm rounded-lg border border-line bg-white p-5 shadow-sm">
        <p className="text-xs uppercase tracking-normal text-slate-500">MelHot Checkout</p>
        <h1 className="mt-1 text-xl font-semibold text-ink">Entrar no admin</h1>
        <div className="mt-5 space-y-3">
          <label className="block">
            <span className="mb-1 block text-xs font-semibold uppercase tracking-normal text-slate-600">E-mail</span>
            <input className="field" value={email} onChange={(event) => setEmail(event.target.value)} />
          </label>
          <label className="block">
            <span className="mb-1 block text-xs font-semibold uppercase tracking-normal text-slate-600">Senha</span>
            <input className="field" type="password" value={password} onChange={(event) => setPassword(event.target.value)} />
          </label>
        </div>
        {login.error && <p className="mt-3 text-sm text-red-600">{login.error.message}</p>}
        <button className="btn mt-5 w-full" disabled={login.isPending}>
          <LogIn size={16} /> Entrar
        </button>
      </form>
    </main>
  );
}
